import React from 'react'

const LayoverPath = () => {
    return (
        <svg width="11" height="77" viewBox="0 0 11 77" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.5 1L5.5 35" stroke="#B3B3B3" stroke-linecap="round" stroke-dasharray="2 3" />
            <circle cx="5.5" cy="38.5" r="5.5" fill="#B3B3B3" />
            <path d="M5.5 42L5.5 76" stroke="#B3B3B3" stroke-linecap="round" stroke-dasharray="2 3" />
        </svg>
    )
}

export default LayoverPath
